import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import {
  Accordion as SemanticAccordion,
  Icon as SemanticIcon,
  Checkbox as SemanticCheckbox,
} from 'semantic-ui-react';

import { Text as TextLayoutComponent, PolymorphicContainer } from '@playbookux/playbook-web-core';

const Accordion = styled(SemanticAccordion)`
  &&& {
    .title {
      padding: 0 !important;
    }

    .active {
      padding: 0 !important;
    }
  }
`;

const Icon = styled(SemanticIcon)`
  float: right;
`;

const TaskDuration = styled(TextLayoutComponent)`
  margin: 10px 0;
`;

const TaskLabel = styled(TextLayoutComponent.Header)`
  &&& {
    margin-bottom: 15px;
    font-size: 14px;
  }
`;

const TaskNumber = styled.a``;

const TaskNumberContainer = styled(TextLayoutComponent.Bold)`
  &&& {
    margin: 15px 0px;
  }
`;

const ContainerWrittenResponse = styled.div`
  border: 1px solid ${(props) => props.theme.color.writtenResponseBorder};
  border-radius: 3px;
  padding: 5px;
  margin-bottom: 5px;
`;

const WrittenResponseText = styled(TextLayoutComponent)``;

const IconContainer = styled(TextLayoutComponent.Bold)`
  &&& {
    margin: 15px 0px;
  }
`;

const ContainerCheckbox = styled.div`
  display: flex;
  flex-direction: column;
  margin-bottom: 30px;
`;

const Checkbox = styled(SemanticCheckbox)`
  &.ui.checkbox input.hidden+label {
    color: ${(props) => props.theme.color.textTitle};
    opacity: 1;
    margin: 5px 0 5px;
  }
`;

const Container = styled(PolymorphicContainer)``;

export const ImageVideoQuestionLabel = ({ href }) => (
  <span>
    Please navigate to
    {' '}
    <a
      target="_blank"
      rel="noopener noreferrer"
      href={href}
    >
      this website
      {' '}
      <sup>
        <SemanticIcon name="external alternate" size="small" />
      </sup>
    </a>
  </span>
);

ImageVideoQuestionLabel.propTypes = {
  href: PropTypes.string.isRequired,
};

export {
  Accordion,
  Checkbox,
  Container,
  ContainerCheckbox,
  ContainerWrittenResponse,
  Icon,
  IconContainer,
  TaskDuration,
  TaskLabel,
  TaskNumber,
  TaskNumberContainer,
  WrittenResponseText,
};
